import React from 'react';
import { node } from 'prop-types';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const propTypes = {
  sidebar: node.isRequired,
  children: node.isRequired,
};

const LayoutBlog = ({ sidebar, children }) => {
  return (
    <Container>
      <Row>
        <Col lg={3}>{sidebar}</Col>
        <Col lg={9}>{children}</Col>
      </Row>
    </Container>
  );
};

LayoutBlog.propTypes = propTypes;

export default LayoutBlog;
